'use strict';

import Log from 'lib/log';
const Alerts = require('lib/alerts');
var EditView = require('./Edit');
const log = Log('row-edit');

module.exports = EditView.extend({
    events: function() {
        var parentEvents = _.isFunction(EditView.prototype.events) ?
            EditView.prototype.events() : EditView.prototype.events;

        return _.extend(_.clone(parentEvents), {
            'click .js-destroy': 'destroyModel',
            'click .js-edit': 'triggerEditView'
        });
    },

    initialize: function(options) {
        this.options = _.defaults(options || {}, {deletable: false});

        return EditView.prototype.initialize.apply(this, [this.options]);
    },

    render: function() {
        var r = EditView.prototype.render.apply(this, arguments);

        this.toggleTainted();

        return r;
    },

    bindHandlers: function() {
        this.model.on('change', this.toggleTainted, this);
        this.model.on('sync', this.toggleTainted, this);

        return EditView.prototype.bindHandlers.apply(this, arguments);
    },

    toggleError: function(attribute, message) {
        this.$('[name=' + attribute + '], .js-attr-' + attribute)
            .closest('.form-group')
            .toggleClass('has-error', !_.isUndefined(message));
        this.$('.error-' + attribute).text(message || '');

        this.$el.toggleClass('has-error', !_.isUndefined(message));
        this.$el.toggleClass('invalid', !_.isUndefined(message));

        return this;
    },

    toggleTainted: function() {
        this.$el.toggleClass('tainted', (
            this.model.isNew() || this.model.dirty()
        ));

        return this;
    },

    triggerEditView: function(ev) {
        ev.preventDefault();
        this.trigger('edit', this.model);
    },

    destroyModel: function() {
        if (this.options.deletable !== true) {
            log.info(`Model is not deletable`);
            return this;
        }

        Alerts.show('dangerConfirm', {
            confirmButtonText: 'Yes, Remove',
            callback: confirm => {
                if (!confirm) {
                    return;
                }

                log.info(`Deleting ${this.model.id}`);
                this.model.destroy().then(() => {
                    if (this.model.collection) {
                        this.model.collection.remove(this.model);
                    }

                    this.remove();
                }, err => { Alerts.show('criticalError', err); });
            }
        });
    }
});



// WEBPACK FOOTER //
// ./app/commons/views/RowEdit.js